<template>
  <!-- 项目数据库页面 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="用户选择:">
              <a-select v-model="query.phone" placeholder="请选择用户" allowClear showSearch :filterOption="filterUserOption"
                @change="handleUserChange">
                <a-select-option v-for="item in userOptions" :key="`${item.id}_${item.phone}`" :value="item.phone">
                  {{ item.userName ? `${item.userName} ${item.phone}` : item.phone }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="采集项目名称:">
              <a-input v-model="query.projectName" placeholder="请输入项目名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-button type="primary" @click="queryList">查询</a-button>
            <a-button style="margin-left: 18px" @click="resetList">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!--表单内容-->
    <a-table size="middle" rowKey="id" bordered :data-source="list" :columns="columns" :pagination="pagination"
      @change="handleTableChange">
      <template slot="action" slot-scope="text, record">
        <img @click="showpoint(record)" :src="require(`@/assets/collectionMappingSystem/seepoint.svg`)" title="点数据"
          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer" />
        <img @click="showline(record)" :src="require(`@/assets/collectionMappingSystem/seeline.svg`)" title="线数据"
          style="margin-right: 8px; width: 18px; height: 18px; cursor: pointer" />
        <img @click="showstatistics(record)" :src="require(`@/assets/collectionMappingSystem/seelinestatistics.svg`)"
          title="管线统计" style="width: 18px; height: 18px; cursor: pointer" />
      </template>
      <template slot="projectCategoryAction" slot-scope="text">
        <span v-if="text == 1">给水</span>
        <span v-else-if="text == 2">排水</span>
        <span v-else-if="text == 3">燃气</span>
        <span v-else-if="text == 4">热力</span>
      </template>
    </a-table>
    <!--点数据弹窗-->
    <a-modal :visible.sync="pointlistDialog" @cancel="pointlistDialog = false" width="70%" title="点数据">
      <a-form layout="inline" style="margin-bottom: 20px">
        <a-row :gutter="20">
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号:">
              <a-input :allowClear="true" v-model="pointForm.intuitionPoint" placeholder="物探点号"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item label="是否收点:">
              <a-select placeholder="是否收点" :allowClear="true" style="width: 120px" v-model="pointForm.closingPoints">
                <a-select-option :value="0">还未收点</a-select-option>
                <a-select-option :value="1">已经收点</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="3" :sm="6" style="display: flex; align-items: center; height: 40px">
            <a-button type="primary" @click="getPointList">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table size="middle" rowKey="id" bordered :data-source="pointList" :columns="pointListcolumns"
          :pagination="pointlistpage" @change="pointpageChange">
          <template slot="closingPoints" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 0">还未收点</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 1">已经收点</a-tag>
          </template>
          <template slot="coordinatesMatch" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 0">还未完成</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 1">已经完成</a-tag>
          </template>
          <!-- <template slot="action" slot-scope="text, record">
            <a @click="showpointupdate(record)">编辑</a>
          </template> -->
        </a-table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
    <!-- 编辑管点弹窗 -->
    <a-modal title="编辑管点" v-model="pointupdateDialog" width="30%" @ok="updatepoint()">
      <a-form :form="pointupdatefrom">
        <a-row>
          <a-col :md="18">
            <a-form-item label="物探点号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="pointupdatedata.intuitionPoint" :disabled="true" style="width: 300px"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="18">
            <a-form-item label="测量经度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['measurementLongitude', { rules: [{ required: true, message: '请输入' }] }]"
                placeholder="请输入" style="width: 300px"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :md="18">
            <a-form-item label="测量纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请输入" style="width: 300px"
                v-decorator="['measurementLatitude', { rules: [{ required: true, message: '请输入' }] }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="18">
            <a-form-item label="地面高程" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请输入" style="width: 300px"
                v-decorator="['groundElevation', { rules: [{ required: true, message: '请输入' }] }]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--线数据弹窗-->
    <a-modal :visible.sync="linelistDialog" @cancel="linelistDialog = false" width="70%" title="线数据">
      <a-form layout="inline" class="search-form" style="margin-bottom: 20px">
        <a-row :gutter="0" type="flex" align="middle">
          <a-col :md="6" :sm="12">
            <a-form-item label="连接点号">
              <a-input :allowClear="true" v-model="lineForm.connectionPointNumber" placeholder="请输入连接点号" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="被连接点号">
              <a-input :allowClear="true" v-model="lineForm.theDotNumberIsConnected" placeholder="请输入被连接点号" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" class="search-buttons">
            <a-button type="primary" @click="getLineList">
              <!-- <a-icon type="search" /> -->
              查询
            </a-button>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <a-table size="middle" rowKey="id" bordered :data-source="lineList" :columns="lineListcolumns"
          :pagination="linelistpage" @change="linepageChange">
          <template slot="flowDirection" slot-scope="text">
            <a-tag color="#C3C1E9" v-if="text == 1">连接点号 → 被连接点号</a-tag>
            <a-tag color="rgb(66, 211, 9)" v-else-if="text == 2">被连接点号 → 连接点号</a-tag>
          </template>
        </a-table>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
    <!--统计弹窗-->
    <a-modal :visible.sync="statisticsDialog" @cancel="statisticsDialog = false" width="40%" title="管线统计">
      <div>
        <template v-if="statisticsList.length > 0">
          <table class="tab" width="100%">
            <thead style="text-align: center; font-weight: bold">
              <tr>
                <th>管类</th>
                <th>类别</th>
                <th>数量</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(listItem, listIndex) in statisticsList">
                <!-- 渲染第一个数据项，并设置rowspan -->
                <tr :key="listIndex">
                  <td align="center" :rowspan="listItem.data.length">
                    {{ listItem.tubeClassName || '--' }}
                  </td>
                  <td align="center">
                    {{ listItem.data[0].type }}
                  </td>
                  <td align="center">{{ listItem.data[0].value }}</td>
                </tr>
                <!-- 渲染剩余的数据项 -->
                <tr v-for="(item, itemIndex) in listItem.data.slice(1)" :key="`${listIndex}-${itemIndex}`">
                  <td align="center">{{ item.type }}</td>
                  <td align="center">{{ item.value }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </template>
        <template v-else>
          <a-empty description="暂无管线统计数据" />
        </template>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import AddModal from '../Secondary-water/Equipment/modules/AddModal.vue'

export default {
  mixins: [mixinViewModule],
  components: { AddModal },
  name: 'ProjectData',
  data () {
    return {
      queryUrl: '/gis-manager/pipeline/project/page',
      addForm: {},
      value: '',
      // 表单数据
      list: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },

      columns: [
        {
          title: '项目名称',
          dataIndex: 'projectName',
        },
        {
          title: '项目类别',
          dataIndex: 'projectCategory',
          scopedSlots: { customRender: 'projectCategoryAction' },
        },
        {
          title: '作业小组',
          dataIndex: 'assignmentGroup',
        },
        {
          title: '业主单位',
          dataIndex: 'ownerOfTheUnit',
        },
        {
          title: '采集单位',
          dataIndex: 'acquisitionUnits',
        },
        {
          title: '负责人',
          dataIndex: 'responsiblePerson',
        },
        {
          title: '创建人手机号码',
          dataIndex: 'phone',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ],
      projectManagementId: '',
      // 分页数据
      pointlistpage: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      pointupdatedata: '',
      pointupdatefrom: this.$form.createForm(this),
      pointlistDialog: false,
      pointupdateDialog: false,
      pointForm: {
        coordinatesMatch: '',
        closingPoints: '',
        intuitionPoint: '',
      },
      pointList: [],
      pointListcolumns: [
        {
          title: '物探点号',
          dataIndex: 'intuitionPoint',
        },
        {
          title: '模糊经度',
          dataIndex: 'obscureLongitude',
        },
        {
          title: '模糊纬度',
          dataIndex: 'obscureLatitude',
        },
        {
          title: '测量经度',
          dataIndex: 'measurementLongitude',
        },
        {
          title: '测量纬度',
          dataIndex: 'measurementLatitude',
        },
        {
          title: '地面高程',
          dataIndex: 'groundElevation',
        },
        {
          title: '管类名称',
          dataIndex: 'tubeClassName',
        },
        {
          title: '管类代码',
          dataIndex: 'tubeClassCode',
        },
        {
          title: '是否收点',
          dataIndex: 'closingPoints',
          scopedSlots: { customRender: 'closingPoints' },
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
        },
      ],

      linelistpage: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      linelistDialog: false,
      lineList: [],
      lineListcolumns: [
        {
          title: '连接点号',
          dataIndex: 'connectionPointNumber',
        },
        {
          title: '被连接点号',
          dataIndex: 'theDotNumberIsConnected',
        },
        {
          title: '流向',
          dataIndex: 'flowDirection',
          scopedSlots: { customRender: 'flowDirection' },
        },
        {
          title: '管线长度',
          dataIndex: 'pipelineLength',
        },
        {
          title: '管类代码',
          dataIndex: 'tubeClassCode',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
      ],
      lineForm: {
        connectionPointNumber: '',
        theDotNumberIsConnected: '',
      },
      statisticsList: [],
      statisticsDialog: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },
      query: {
        phone: undefined,
        projectName: '',
        createTime: undefined,
      },
      // 排序参数
      sorter: {
        field: null,
        order: null
      },
      userOptions: [],
    }
  },
  computed: {},
  created () {
    this.getUserList() // 获取用户列表
    this.queryList() // 获取表格数据
    this.$store.commit('SET_SYSTEMNAME', '合汇采集宝')

  },
  methods: {
    showpointupdate (record) {
      this.pointupdatedata = Object.assign({}, record)

      this.$nextTick(() => {
        this.pointupdatefrom.setFieldsValue(record)
      })

      this.pointupdateDialog = true
    },
    showpoint (record) {
      this.projectManagementId = record.id
        ; (this.pointForm = {
          coordinatesMatch: '',
          closingPoints: '',
          intuitionPoint: '',
        }),
          this.getPointList()
    },
    showline (record) {
      this.projectManagementId = record.id
        ; (this.lineForm = {
          connectionPointNumber: '',
          theDotNumberIsConnected: '',
        }),
          this.getLineList()
    },
    getPointList (item) {
      this.$http
        .get('/gis-manager/pipeline/point/page', {
          params: {
            intuitionPoint: this.pointForm.intuitionPoint,
            closingPoints: this.pointForm.closingPoints,
            coordinatesMatch: this.pointForm.coordinatesMatch,
            projectManagementId: this.projectManagementId,
            page: this.pointlistpage.current,
            limit: this.pointlistpage.pageSize,
          },
        })
        .then((res) => {
          let data = res.data
          this.pointList = data.list
          this.pointlistpage.total = Number(data.total)
          this.pointlistDialog = true
        })
    },
    updatepoint () {
      const that = this
      // 触发表单验证
      this.pointupdatefrom.validateFields((err, values) => {
        if (!err) {
          const params = Object.assign(
            { intuitionPoint: this.pointupdatedata.intuitionPoint, id: this.pointupdatedata.id },
            values
          )

          this.$http
            .post('/gis-manager/pipeline/point/update/', params)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success(res.message)
                this.getPointList()
                this.pointupdateDialog = false
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(() => { })
        }
      })
    },
    pointpageChange (pagination, filters, sorter) {
      this.pointlistpage.current = pagination.current
      this.pointlistpage.pageSize = pagination.pageSize
      this.getPointList()
    },
    //线
    getLineList (item) {
      this.$http
        .get('/gis-manager/pipeline/pipe/page', {
          params: {
            theDotNumberIsConnected: this.lineForm.theDotNumberIsConnected,
            connectionPointNumber: this.lineForm.connectionPointNumber,
            projectManagementId: this.projectManagementId,
            page: this.linelistpage.current,
            limit: this.linelistpage.pageSize,
          },
        })
        .then((res) => {
          let data = res.data
          this.lineList = data.list
          this.linelistpage.total = Number(data.total)
          this.linelistDialog = true
        })
    },
    linepageChange (pagination, filters, sorter) {
      this.linelistpage.current = pagination.current
      this.linelistpage.pageSize = pagination.pageSize
      this.getLineList()
    },
    //管线统计
    showstatistics (record) {
      this.statisticsList = []
      this.$http.get('/gis-manager/pipeline/statistics/list/' + record.id).then((res) => {
        let value = res.data
        if (value && value.length > 0) {
          value.map((item) => {
            this.statisticsList.push({
              tubeClassName: item.tubeClassName,
              data: [
                { type: '点', value: item.numberOfPoints },
                { type: '线', value: item.lineQuantity },
                { type: '管线长度', value: item.pipeNetworkLength + 'm' },
              ],
            })
          })
          this.statisticsDialog = true
        } else {
          this.$message.info('暂无管线统计数据')
        }
      }).catch(err => {
        this.$message.error('获取管线统计数据失败')
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, current: pagination.current, pageSize: pagination.pageSize }

      // 记住排序值
      if (sorter && sorter.field) {
        this.sorter.field = sorter.field
        this.sorter.order = sorter.order
      } else {
        // 如果没有排序，清空排序参数
        this.sorter.field = null
        this.sorter.order = null
      }

      this.queryList() // 重新获取数据
    },
    queryList () {
      const params = {
        ...this.query,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      }

      // 处理日期格式
      if (params.createTime) {
        params.createTime = params.createTime.format('YYYY-MM-DD')
      }

      // 如果phone为undefined或null，从参数中删除
      if (!params.phone) {
        delete params.phone
      }

      // 添加排序参数
      if (this.sorter.field && this.sorter.order) {
        params.sortField = this.sorter.field
        params.sortOrder = this.sorter.order === 'ascend' ? 'asc' : 'desc'
      }

      this.$http
        .get(this.queryUrl, { params })
        .then((res) => {
          if (res.code === 0) {
            this.list = res.data.list || []
            this.pagination.total = Number(res.data.total || 0)
          } else {
            this.$message.error(res.message || '获取数据失败')
          }
        })
        .catch((error) => {
          console.error('获取列表数据失败:', error)
          this.$message.error('获取数据失败')
        })
    },
    resetList () {
      this.query = {
        phone: undefined,
        projectName: '',
        createTime: undefined,
      }
      // 重置排序参数
      this.sorter = {
        field: null,
        order: null
      }
      this.pagination.current = 1
      this.queryList()
    },
    search () {
      this.pagination.current = 1 // 重置到第一页
      this.queryList()
    },
    // 获取用户列表
    async getUserList () {
      try {
        const res = await this.$http.get('/gis-manager/user/deploy/user/list')
        if (res.code === 0) {
          // 确保数据的完整性
          this.userOptions = (res.data || []).filter(item => {
            return item && item.id && item.phone && !item.isDeleted // 确保必要字段存在
          })
        } else {
          this.$message.error(res.message || '获取用户列表失败')
        }
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error('获取用户列表失败')
      }
    },
    // 用户选择变化处理
    handleUserChange (value) {
      this.query.phone = value
      // this.queryList()
    },
    // 添加用户选择过滤方法
    filterUserOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    resetForm () {
      this.lineForm = {
        connectionPointNumber: '',
        theDotNumberIsConnected: '',
      }
      this.linelistpage.current = 1
      this.getLineList()
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.tab {
  font-size: 16px;
  font-weight: normal;
  border-collapse: collapse;

  tr td {
    height: 50px;
    border: 1px solid #d5ecfc;
  }

  tr th {
    width: 33.33%;
    /* 假设你有三个表头，每个占1/3 */
    height: 50px;
  }
}

.bt:before {
  content: '* ';
  color: red;
}
</style>
